import React, { useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

const DashboardSummery = () => {
    const data = {
        labels: ['Energy', 'Water', 'Work Orders', 'Others'],
        datasets: [
            {
                label: 'Usage',
                data: [58, 45, 32, 16],
                backgroundColor: [
                    '#fdd76c', // Energy
                    '#298077', // Water
                    '#63ccc5', // Work Orders
                    '#166c87', // Others
                ],
            },
        ],
    };
    const options = {
        responsive: true,
        maintainAspectRatio: true, // Maintain the aspect ratio of the chart
        plugins: {
            legend: {
                display: false, // Disable the default legend
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return tooltipItem.label + ': ' + tooltipItem.raw + '%';
                    },
                },
            },
        },
    };
    useEffect(() => {
        // const ctx = document.getElementById('doughnutChart').getContext('2d');
        // const rangeDisplay = document.getElementById('rangeDisplay');

        // const data = {
        //     labels: ['Energy', 'Water', 'Work Orders', 'Others'],
        //     datasets: [{
        //         label: 'Usage',
        //         data: [58, 45, 32, 16], // percentages for each category
        //         backgroundColor: [
        //             '#fdd76c',    // Energy
        //             '#298077',     // Water            
        //             '#63ccc5',   // Work Orders
        //             '#166c87'       // Others
        //         ],
        //         // borderColor: '#2a2a4d',
        //         // borderWidth: 2
        //     }]
        // };

        // const config = {
        //     type: 'doughnut',
        //     data: data,
        //     options: {
        //         responsive: true,
        //         maintainAspectRatio: true, // Maintain the aspect ratio of the chart
        //         plugins: {
        //             legend: {
        //                 display: false // Disable the default legend
        //             },
        //             tooltip: {
        //                 callbacks: {
        //                     label: function (tooltipItem) {
        //                         return tooltipItem.label + ': ' + tooltipItem.raw + '%';
        //                     }
        //                 }
        //             }
        //         }
        //     }
        // };

        // const myDoughnutChart = new Chart(ctx, config);
        // return (
        //     myDoughnutChart.destroy()
        // )
    }, [])
    return (
        <div className='mainSection'>
            <div className="box px-2">
                <div className="dashboard p-3">
                    <h6 className="text-center text-light"><b>Summary Dashboard</b></h6>
                    <div className="sumry p-1 mt-4">
                        <li><span>No . of buildings</span> <span>5</span></li>
                        <li><span>Total Energy Used:</span> <span>540 kwh</span></li>
                        <li><span>Avrage Energy-per Building:</span> <span>630 kwh</span></li>
                        <li><span>Total Numbers of Assets</span> <span>150</span></li>
                        <li><span>Number of Occupants</span> <span>40</span></li>
                    </div>
                </div>
                <div className="circleGraph mt-3 bg-light">
                    <h5 className="text-center mb-2 mt-2">Efficiency</h5>
                    <div className="chart-container p-3">

                        <div className="chart-wrapper">
                            {/* <canvas id="doughnutChart"></canvas> */}
                            <div style={{ width: '100%', height: '100%' }}>
                                <Doughnut data={data} options={options} />
                            </div>
                            <div className="range-display" id="rangeDisplay"></div>
                        </div>
                        <div className="labels-container">
                            <div className="label energy-label">
                                <div className="color-box"></div>
                                <span>Energy</span>
                            </div>
                            <div className="label water-label">
                                <div className="color-box"></div>
                                <span>Water</span>
                            </div>
                            <div className="label work-orders-label">
                                <div className="color-box"></div>
                                <span>Work Orders</span>
                            </div>
                            <div className="label others-label">
                                <div className="color-box"></div>
                                <span>Others</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DashboardSummery; 